// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"43dc7763","455":"ff714e61","497":"0797bf68","977":"c4643c4d"}[chunkId] + ".chunk.js";
};